import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IShopInfo } from '@/types/components/shop';

const initialState: IShopInfo = {
  plan: '',
  subscription: '',
  currency: '',
  isDisableCheckoutButton: false,
  isDisableAddToCartButton: false,
  showBannerContact: false,
  isLoading: false
};

const shopInfoSlice = createSlice({
  name: 'shopInfo',
  initialState,
  reducers: {
    handleSaveShopInfo: (state, action: PayloadAction<Partial<IShopInfo>>) => {
      return { ...state, ...action.payload };
    },
    handleResetShopInfo: () => initialState,
  },
});

export const shopInfoSelector = createSelector(
  (state: RootState) => state.shopInfo,
  (state) => state,
);

export const { handleSaveShopInfo, handleResetShopInfo } = shopInfoSlice.actions;

export default shopInfoSlice;
